export default __webpack_public_path__ + "static/media/hijab6.afdbbc09.png";